import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'adjustmentReason',
    label: 'Adjustment Reason',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'adjustmentAmount',
    label: 'Adjustment Amount',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'adjustmentComment',
    label: 'Adjustment Comment',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const customAdjustmentsForm = {
  name: FormNames.CUSTOM_ADJUSTMENTS,
  label: 'Custom Adjustments',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
